import { useState, useEffect } from "react";
import { useUser } from "utils/hooks";
import API from "utils/api";

let CONFIG_CACHE = null;
let CONFIG_PROMISE = null;

export default function useConfig() {
  const { token } = useUser();
  const [loading, setLoading] = useState(() => CONFIG_CACHE === null);
  let mounted = true;

  async function fetchConfig(force = false) {
    if (CONFIG_CACHE !== null && force === false) {
      return;
    }

    setLoading(true);

    if (!CONFIG_PROMISE) {
      CONFIG_PROMISE = API.fetchConfig(token);
    }

    const { response, data } = await CONFIG_PROMISE;

    if (response.ok) {
      CONFIG_CACHE = data;
      CONFIG_PROMISE = null;

      if (mounted) {
        setLoading(false);
      }
    } else {
      console.error(data);
    }
  }

  useEffect(() => {
    fetchConfig();

    return () => { mounted = false };
  }, []);

  return {
    loading,
    refresh: () => fetchConfig(true),
    config: CONFIG_CACHE ?? { categories: [] },
  };
}
